import {
  groupOrderRefund,
  cancelOrder,
} from "@saas/service-api/src/learning-center";
import { PAY_TYPE } from "@saas/components/src/constants";
import { handleImageUrl, CountDown, isMobile } from "@saas/components/src";
import moment from "moment";
export default {
  props: {
    orderInfo: {
      type: Object,
      default: () => { },
    },
  },
  data: function () {
    return {
      isMobile: isMobile(),
      payType: PAY_TYPE,
      handleImageUrl,
      moment,
      showMore: false,
      length: 1, //默认展示1条
      isElectron: window.isElectron,
    };
  },
  methods: {
    callback() {
      // 超时
      this.orderInfo.state = 3;
    },
    groupRefund() {
      this.$confirm(
        "<div>取消拼团后，该订单将关闭、支付金额会原路退回，账号不计入拼团人数，是否确认取消拼团？</div>",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.apiGroupOrderRefund();
        })
        .catch(() => { });
    },
    apiGroupOrderRefund() {
      groupOrderRefund({ order_no: this.orderInfo.order_no }).then((res) => {
        if (res.code === 1) {
          this.$message.success("拼团取消完成");
          this.$emit("refresh");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    goGroupInfo() {
      this.$router.push(`/group-info/${this.orderInfo.activity_id}`);
    },
    jumpPayment() {
      this.$router.push(`/payment/${this.orderInfo.order_no}`);
    },
    handleCancelOrder() {
      this.$confirm(
        `<div>取消订单后，订单将关闭、无法支付。是否确认取消？<div>`,
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确认",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let params = {
            order_no: this.orderInfo.order_no,
          };
          cancelOrder(params).then((res) => {
            if (res.code === 1) {
              this.$emit("refresh");
              this.$message.success("订单取消完成");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
    formatPrice(val) {
      if (val) {
        return "￥" + (val / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    refund(obj) {
      this.$emit("refund", obj);
    },
    showUseDetail(obj) {
      this.$emit("showUseDetail", obj);
    },
    jumpProductDetail(id) {
      let url = `/product-detail/${id}`;
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    showMoreCourse() {
      this.length = this.orderInfo?.sub_order_list?.length || 1;
      this.showMore = true;
    },
    closeMoreCourse() {
      this.length = 1;
      this.showMore = false;
    },
    // 填写地址
    inputAddress(orderInfo) {
      if (this.showViewAddressBtn) {
        this.$emit("showAddress", orderInfo);
      } else {
        this.$emit("selectAddress", orderInfo);
      }
    },
  },
  computed: {
    showPayType() {
      if (this.signUpSuccess) {
        // 报名成功
        return true;
      } else if (this.orderInfo.state === 1) {
        //待支付
        return false;
      } else if (["超时未支付", "已取消"].includes(this.handleFailTips)) {
        return false;
      } else if (this.orderInfo.group_state === 1) {
        //待成团
        return true;
      } else {
        return true;
      }
    },
    signUpSuccess() {
      let { state, group_state, activity_type } = this.orderInfo;
      if (activity_type === 4) {
        return group_state === 2 && [2, 5].includes(state);
      } else {
        return [2, 5].includes(state);
      }
    },
    handleFailTips() {
      let { state, group_state, activity_type, reply_result } = this.orderInfo;
      if (activity_type === 4) {
        if (group_state === 3) {
          return "拼团失败";
        } else if ([1, 2].includes(reply_result)) {
          return "已取消拼团";
        }
      }
      if (state === 3) {
        return "超时未支付";
      } else if (state === 4) {
        return "已取消";
      }
      return "";
    },
    showMoreBtn() {
      return this.orderInfo?.sub_order_list?.length > 1;
    },
    showGroupInfoBtn() {
      let { activity_type, state, group_state } = this.orderInfo;
      return activity_type === 4 && state !== 1 && group_state;
    },
    showInputAddressBtn() {
      // 展示填写收货地址按钮的条件
      // 用户下单时课程是需要邮寄的状态
      // 订单处于报名完成状态
      // 订单未退款成功，已申请退款但未同意退款也是未退款成功
      return (
        this.orderInfo.is_mail === 1 &&
        this.orderInfo.state === 2 &&
        this.orderInfo.reply_result !== 2 &&
        !this.orderInfo.address
      );
    },
    showViewAddressBtn() {
      return (
        this.orderInfo.is_mail === 1 &&
        this.orderInfo.state === 2 &&
        this.orderInfo.reply_result !== 2 &&
        this.orderInfo.address
      );
    },
  },
  watch: {
    orderInfo: {
      handler: function (newVal) {
        if (newVal?.sub_order_list?.length === 1) {
          let { state, group_state, real_price, channel, reply_result } =
            newVal.sub_order_list[0];
          newVal.state = state;
          newVal.group_state = group_state;
          newVal.real_price = real_price;
          newVal.channel = channel;
          newVal.reply_result = reply_result;
        }
      },
      immediate: true,
    },
  },
  components: {
    CountDown,
  },
};
